module.exports = __webpack_public_path__ + "static/media/1.89c3dbb4.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/1.JPG
// module id = 441
// module chunks = 0